<input type="text" 
  [(ngModel)]="convertedValue" 
  (keydown)="handleKeyDown($event)" 
  (blur)="onChange($event)" 
  (focus)="focus($event)" />